import { render, staticRenderFns } from "./EditAmountPopup.vue?vue&type=template&id=0d7ff0ca&scoped=true&"
import script from "./EditAmountPopup.vue?vue&type=script&lang=js&"
export * from "./EditAmountPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditAmountPopup.vue?vue&type=style&index=0&id=0d7ff0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ff0ca",
  null
  
)

export default component.exports